import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Phonics Grand Prix',
    description: "A 3D racing adventure for Year 1 pupils: explore Phonics Racing Island, blend CVC words to fix your car, unlock tracks and win the Grand Prix.",
    placeholder: 'Loading Phonics Racing Island',
    url: getOrigin()
}
